export const colors = {
    downy: "#78CFC0",
    sandyBrown: "#EDA751",
    manhattan: "#F6CF85",
    rawSienna: "#CD853F"
}